import styled from "styled-components";
import { SLForm } from "~/pages/Sistema/componentes/SistemaList";
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Colors } from "~/config/Colors";

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .padding-form {
    padding: 0 1em 1em 1em;
  }

  .row {
    margin-bottom: 0.5em;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .text-separador {
    font-size: 0.8em;
    line-height: 1em;
    color: ${Colors.Color7};
  }
`;

export const CustomScrollBarCust = styled(CustomScrollBar)`
  overflow: hidden;
  // height: 23em !important;
`;